__turbopack_context__.v({
  "className": "gamja_flower_80e871b-module__epeTCW__className",
});
